import { ResourceItemComment } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";
import { type IntlShape } from "react-intl";

import { getPlatformStringFromConnectionCategory } from "../../common";
import { MESSAGES } from "../message-definitions";

import { AirConnectionResponseItems, commentTruncation } from "./shared";

export const getReconnectConnectionResponseChildren = (
  intl: IntlShape,
  air: FundingApplicationSchemas.AdditionalInformationRequestWithMetaSchema
) => {
  const _commentTruncation = commentTruncation(intl);
  const airData = air.data as FundingApplicationSchemas.ReconnectConnectionAIRSchema;
  const airResponse = air.response as FundingApplicationSchemas.ReconnectConnectionAIRResponse;
  const connectionResponseMetaData = air.meta as FundingApplicationSchemas.ConnectionMetadataSchema[];

  // Connected supported platform
  if (airResponse.reconnected_connection_id) {
    return <AirConnectionResponseItems connectionMetaData={connectionResponseMetaData} />;
  }
  // Submitted "other" free text response
  if (airResponse.cannot_reconnect_connection_reason === "other" && airResponse.reason) {
    return <ResourceItemComment truncation={_commentTruncation} text={airResponse.reason ?? ""} />;
  }
  // Submitted reason code
  if (airResponse.cannot_reconnect_connection_reason === "store_decommissioned") {
    return (
      <ResourceItemComment
        truncation={_commentTruncation}
        text={intl.formatMessage(MESSAGES.reasonPreviousPlatformDecommissionedOption, {
          platformType: getPlatformStringFromConnectionCategory(
            intl,
            airData.connection_meta_data?.type,
            airData.connection_identifier ?? ""
          ),
        })}
      />
    );
  }
};
